export enum KnownVisitSources {
    SeoHotels = 'seo-hotels',
    SeoTours = 'seo-tours'
}
